<template>
  <div
    class="share-access-table__row user-info user-info--owner"
    :class="{ 'user-info--mobile': $vuetify.breakpoint.width < 475 }"
  >
    <div class="share-access-table__col-person">
      <div class="user-info__person">
        <v-avatar size="32px" class="user-info__avatar">
          <v-img :src="getAvatarUrl(email, 48)" />
        </v-avatar>
        <div class="user-info__details">
          <p
            class="user-info__name primary-onhover mb-0 text-truncate"
            :title="ownerDisplayName"
          >
            <span v-if="isYou">{{
              $t("table.field.userOwner", { name: name })
            }}</span>
            <span v-else>{{ name }}</span>
          </p>
          <p
            v-if="name !== email"
            class="user-info__email p-3 mb-0 primary-onhover text-truncate"
            :title="email"
          >
            {{ email }}
          </p>
        </div>
      </div>
    </div>

    <div class="share-access-table__col-role">
      <span class="user-info__owner-role">{{ $t("general.owner") }}</span>
    </div>

    <div
      v-if="showSsoColumn"
      class="share-access-table__col-login-as"
    />

    <div class="share-access-table__col-actions" />
  </div>
</template>

<script>
import { getAvatarUrl } from "@/apis/HelperFunctions";

export default {
  props: {
    name: String,
    email: String,
    showSsoColumn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      getAvatarUrl,
    };
  },
  computed: {
    isYou() {
      return this.$store.state.home.user.email == this.email;
    },
    ownerDisplayName() {
      if (this.isYou) {
        return this.$t("table.field.userOwner", { name: this.name });
      }
      return this.name;
    },
  },
};
</script>

<style lang="scss" scoped>
.share-access-table__row {
  display: grid;
  grid-template-columns: var(--share-access-grid-columns);
  gap: 8px 12px;
  align-items: center;
  padding: 10px 16px;
  border-bottom: 1px solid var(--v-gray-lighten4);
  transition: background-color 0.24s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: var(--v-panel-lighten1);

    .primary-onhover {
      color: var(--v-primary-base) !important;
    }
  }

  &.user-info--mobile {
    @media (max-width: 475px) {
      grid-template-columns: 1fr;
      gap: 12px;
    }
  }
}

.share-access-table__col-person {
  min-width: 0;
  overflow: hidden;
  padding-right: 4px;
}

.share-access-table__col-role,
.share-access-table__col-login-as {
  min-width: 0;
}

.user-info {
  &__person {
    display: flex;
    align-items: flex-start;
    min-width: 0;
    overflow: hidden;
    width: 100%;
  }

  &__avatar {
    flex-shrink: 0;
    border: 1px solid var(--v-gray-lighten2) !important;
  }

  &__details {
    min-width: 0;
    margin-left: 12px;
    overflow: hidden;
    flex: 1 1 auto;
  }

  &__name {
    font-weight: $font-weight-bold;
    color: var(--v-gray-darken2);
    font-size: $font-size-sm;
    line-height: $line-height-sm;
    min-width: 0;
  }

  &__email {
    color: var(--v-gray-darken1);
    margin-top: 2px;
    min-width: 0;
  }

  &__owner-role {
    font-weight: $font-weight-semibold;
    color: var(--v-gray-lighten1);
    font-size: $font-size-sm;
  }

  .primary-onhover {
    transition: color 0.24s ease;
  }
}
</style>
